import gql from 'graphql-tag'

export const RESOUCE_SET_BY_NAME = gql`
    query ResourceCollection ($name: String, $locale: String, $preview: Boolean) {
        resourceSetCollection(
            limit: 1
            where: { name: $name }
            locale: $locale
            preview: $preview
        ) {
                items {
            resourcesCollection {
                items {
                            key
                value { json }
                }
            }
            }
        }
    }
`
